/**
 * Mengenrabatt — quantity tier picker
 * Writes the selected tier quantity into the main product form, so
 * "In den Warenkorb" adds 1, 2 or 5 (as configured) items.
 * The block markup is re-rendered on variant change (product-info.js),
 * so the selection is restored afterwards.
 */
if (!customElements.get('mengenrabatt-picker')) {
  customElements.define(
    'mengenrabatt-picker',
    class MengenrabattPicker extends HTMLElement {
      connectedCallback() {
        this.selectedQty = this.querySelector('.mengenrabatt__input:checked')?.value || '1';

        this.onChange = (event) => {
          if (!event.target.matches('.mengenrabatt__input')) return;
          this.selectedQty = event.target.value;
          this.syncQuantity();
        };
        this.onVariantChange = () => this.restoreSelection();

        this.addEventListener('change', this.onChange);
        document.addEventListener('variant-change', this.onVariantChange);
        this.syncQuantity();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        document.removeEventListener('variant-change', this.onVariantChange);
      }

      restoreSelection() {
        const input =
          this.querySelector(`.mengenrabatt__input[value="${this.selectedQty}"]`) ||
          this.querySelector('.mengenrabatt__input');
        if (!input) return;
        input.checked = true;
        this.selectedQty = input.value;
        this.syncQuantity();
      }

      syncQuantity() {
        const formId = this.dataset.formId;
        const themeInputs = document.querySelectorAll(`.quantity__input[form="${formId}"]`);
        const fallbackInput = this.querySelector('[data-mengenrabatt-quantity]');

        // Prefer the theme quantity input (hidden via CSS) so only one "quantity" field is submitted
        if (themeInputs.length) {
          themeInputs.forEach((input) => {
            input.value = this.selectedQty;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          if (fallbackInput) fallbackInput.disabled = true;
        } else if (fallbackInput) {
          fallbackInput.value = this.selectedQty;
          fallbackInput.disabled = false;
        }
      }
    }
  );
}
